import { createAuthClient } from "better-auth/react";
import { getBearerToken } from "./auth-store";

// BetterAuth React client configured to use bearer tokens instead of
// cookies. We override the global fetch so every request from the
// auth client (including useSession polls) carries the Authorization
// header from our in-memory token store.
export const authClient = createAuthClient({
  fetchOptions: {
    customFetchImpl: ((url: string | URL | Request, init?: RequestInit) => {
      const token = getBearerToken();
      if (token) {
        const headers = new Headers(init?.headers);
        headers.set("Authorization", `Bearer ${token}`);
        return fetch(url, { ...init, headers });
      }
      return fetch(url, init);
    }) as typeof fetch,
  },
});

export const { useSession, signOut } = authClient;
